<template>
  <LvFlexBox noWrap gap8 alignItems="center" class="lv-duration-time-input">
    <LvFlexBox noWrap gap8 alignItems="center" class="lv-duration-time-input__duration">
      <LvNumberStepper :value="duration" @input="$emit('input-duration', $event)" />
      <LvText h5 noWrap>{{ $t('分') }}</LvText>
    </LvFlexBox>
    <LvFlexBox noWrap gap8 alignItems="center" class="lv-duration-time-input__time">
      <TimePicker
        :value="_startDate"
        :clearable="false"
        class="lv-duration-time-input__start"
        @input="$_onInputStart($event)"
      />
      <LvText h5 noWrap lightGray class="lv-duration-time-input__end">~ {{ _endText }}</LvText>
    </LvFlexBox>
    <IconButton
      v-if="isCustomStart"
      icon="icon-refresh"
      tooltipText="還原"
      @click="$emit('reset-start')"
    />
    <div v-else class="lv-duration-time-input__reset-placeholder" />
  </LvFlexBox>
</template>

<script>
const TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export default {
  props: {
    duration: {
      type: Number,
      default: null,
    },
    startAt: {
      type: String,
      default: '',
    },
    endAt: {
      type: String,
      default: '',
    },
    isCustomStart: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // TimePicker 內部用 new Date(value)，直接給字串在 Safari 會解析失敗，所以先轉成 Date
    _startDate() {
      return this.startAt ? this.$moment(this.startAt, TIME_FORMAT).toDate() : null;
    },
    _endText() {
      return this.endAt ? this.$moment(this.endAt, TIME_FORMAT).format('HH:mm') : '--:--';
    },
  },
  methods: {
    $_onInputStart($event) {
      if (!$event) return;
      this.$emit('input-start', $event.format('HH:mm'));
    },
  },
};
</script>
